import { Controller } from '@hotwired/stimulus'
import { ComponentData, trackComponent } from 'critical/tracking'

interface Params {
  params: {
    index: number
    dataclicktracking: ComponentData & { additionalProps: object }
  }
}

export default class extends Controller<HTMLFormElement> {
  static override targets = ['radioButtonLabel', 'text']

  declare readonly radioButtonLabelTargets: HTMLElement[]
  declare readonly textTargets: HTMLElement[]

  index = 0

  override initialize() {
    this.displayCurrentSelection()
  }

  radioButtonClicked({ params: { index, dataclicktracking } }: Params): void {
    this.index = index
    this.displayCurrentSelection()
    trackComponent(
      'Dynamic Component Event',
      'RadioButtonClicked',
      dataclicktracking,
      dataclicktracking.additionalProps,
    )
  }

  displayCurrentSelection() {
    this.radioButtonLabelTargets.forEach((label, i) => {
      label.classList.remove('radio-checked')
      if (i === this.index) {
        label.classList.add('radio-checked')
      }
    })
    this.textTargets.forEach((element, i) => {
      element.hidden = i !== this.index
    })
  }
}
